/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.ComAi.Feedback.Headline';
export const Body = 'Website.ComAi.Feedback.Body';
export const Dismiss = 'Website.ComAi.Feedback.Dismiss';
export const Send = 'Website.ComAi.Feedback.Send';
